
import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * Skeleton for the entire settings panel (initial load)
 */
export function FullSettingsSkeleton() {
  return (
    <div className="p-2 space-y-4">
      {/* Model selector skeleton */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-8 w-[180px]" />
      </div>

      {/* Settings items skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-4 w-24" />
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8 w-20" />
          </div>
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-8 w-32" />
          </div>
        </div>
      </div>

      {/* Style settings skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-4 w-28" />
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-28" />
          </div>
        </div>
      </div>

      {/* Advanced settings skeleton */}
      <div className="space-y-3">
        <Skeleton className="h-4 w-32" />
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8 w-24" />
          </div>
        </div>
      </div>
    </div>
  )
}

/**
 * Skeleton for settings sections only (when model changes)
 * Model selector stays visible
 */
export function SettingsSectionsSkeleton() {
  return (
    <div className="px-2 space-y-4 mt-4">
      <div className="border-t border-border" />

      {/* Settings items skeleton */}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-8 w-20" />
        </div>
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-8 w-32" />
        </div>
      </div>

      {/* Style section skeleton */}
      <div className="space-y-3 mt-6">
        <Skeleton className="h-4 w-28" />
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-28" />
          </div>
        </div>
      </div>

      {/* Advanced section skeleton */}
      <div className="space-y-3 mt-6">
        <Skeleton className="h-4 w-32" />
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-8 w-24" />
          </div>
        </div>
      </div>
    </div>
  )
}
